// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-container[data-v-3761faea]{-webkit-box-flex:1;-ms-flex:1;flex:1}.certificate-link[data-v-3761faea]{overflow-wrap:anywhere;text-align:left;-webkit-transition:.3s;transition:.3s;cursor:pointer}.certificate-link[data-v-3761faea]:hover{opacity:.7}", ""]);
// Exports
module.exports = exports;
